
import {  SOURCING_MANAGER_DETAILS, SOURCING_MANAGER_LIST } from "../types";
  
const initialState = {
  response: null,
  loading: true,
  create: false,
  detail: false,
  update:false,
};


export default function sourcingManagerStore(state = initialState, action) {
  switch (action.type) {
    case SOURCING_MANAGER_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
      case SOURCING_MANAGER_DETAILS:
        return {
          ...state,
          loading: false,
          create: false,
          detail: true,
          response: action.payload,
        };
    default:
      return state;
  }
}